import { Coords, Waypoint } from "types/app";
import { parseWaypointForAPI } from "utils/helpers/waypointParser/waypointParser";
import { encodeTracksToGPX } from "./encodeTracksToGPX";
import { encodeWaypointsToGPX } from "./encodeWaypointsToGPX";

type EncodeGPXparams = {
  waypoints?: Waypoint[] | null;
  tracks?: {
    trackPoints?: Coords[];
    trackPointsEle?: number[];
    description?: string;
    name?: string;
    links?: string[];
    comment?: string;
    number?: string;
    type?: string;
    source?: string;
  }[];
};

export const encodeGPX = ({ waypoints, tracks }: EncodeGPXparams) => {
  const result = ['<?xml version="1.0" encoding="UTF-8"?>'];
  result.push(
    `<gpx version="1.1" creator="Trackbook - ${window.location.origin}" xmlns="http://www.topografix.com/GPX/1/1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd">`
  );
  if (waypoints) {
    const parsed = waypoints.map((waypoint) => ({
      ...parseWaypointForAPI(waypoint),
      // Not part of the API format, but needed for the waypoint's <ele>
      ele: waypoint.ele,
    }));
    result.push(encodeWaypointsToGPX(parsed));
  }
  if (tracks) {
    tracks.forEach(
      ({
        trackPoints,
        trackPointsEle,
        description,
        links,
        name,
        comment,
        number,
        type,
        source,
      }) => {
        if (trackPoints?.length) {
          // Elevations are only exported when there's one for each point, otherwise they'd be
          // assigned to wrong points (e.g. not loaded yet for a new route). The track is exported anyway.
          const elevations =
            trackPointsEle?.length === trackPoints.length
              ? trackPointsEle
              : undefined;
          result.push(
            encodeTracksToGPX(
              trackPoints,
              elevations,
              name || "Track",
              description,
              links,
              comment,
              number,
              type,
              source
            )
          );
        }
      }
    );
  }
  result.push("</gpx>");

  return result.join("\n");
};
